import { useOption } from '@react-aria/listbox';
import { ListState } from '@react-stately/list';
import { Node } from '@react-types/shared';
import { useRef } from 'react';

import { classNames } from '@/utils/classnames';

interface Props {
  item: Node<unknown>;
  state: ListState<unknown>;
}

export function Option({ item, state }: Props) {
  const ref = useRef<HTMLLIElement>(null);
  const isSelected = state.selectionManager.isSelected(item.key);
  const isFocused = state.selectionManager.focusedKey === item.key;

  const { optionProps } = useOption(
    {
      key: item.key,
      isSelected,
      shouldSelectOnPressUp: true,
      shouldFocusOnHover: true,
      shouldUseVirtualFocus: true,
    },
    state,
    ref,
  );

  return (
    <li
      {...optionProps}
      ref={ref}
      className={classNames(
        'flex',
        'items-center',
        'rounded-sm',
        'mx-0',
        'cursor-pointer',
        'h-14',
        'focus:outline-none',
        'focus:bg-token-gray-200',
        'active:outline-none',
        'hover:bg-token-gray-200',
        'border-0',
        'outline-none',
        'hover:bg-token-gray-200',
        '[#landing-page_li:last-child_ul_&]:last:rounded-b-[1.75rem]',
        '[#token-select_li:last-child_ul_&]:last:rounded-b-[1.125rem]',
        'aria-disabled:hover:bg-transparent',
        'aria-disabled:focus:bg-transparent',
        'aria-disabled:cursor-not-allowed',
        'aria-disabled:opacity-50',
        isFocused ? 'bg-token-gray-200' : undefined,
      )}
    >
      {item.rendered}
    </li>
  );
}
